import { render, staticRenderFns } from "./task-activities.vue?vue&type=template&id=2d4a409d&scoped=true&"
import script from "./task-activities.vue?vue&type=script&lang=ts&"
export * from "./task-activities.vue?vue&type=script&lang=ts&"
import style0 from "./task-activities.vue?vue&type=style&index=0&id=2d4a409d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4a409d",
  null
  
)

export default component.exports